import React, { useState, useEffect } from 'react'
import { Modal, Image, Button, Space } from 'antd'
import { addReadTimes, agreeAuthorization, getAgreement, getNoAgreeAuthorization, postAgreement } from '@/services/mendian'
import styles from './index.module.less'

const AgreementModal = () => {
  const [visible, setVisible] = useState(false)
  const [authorizationModalData, updateAuthorizationModalData] = useState<any>({})
  const [showAuthorizationModal, updateShowAuthorizationModal] = useState<boolean>(false)

  useEffect(() => {
    getNoAgreeAuthorization().then(res => {
      const list = res?.list || []
      if (list.length && list[0]) {
        const authData = list[0]
        updateAuthorizationModalData(authData)
        updateShowAuthorizationModal(true)
        handleRefuseAuth(authData.id)
      }
    })
    getAgreement().then((res) => {
      if (window.location.pathname === '/solar/metis/platform-agreement') {
        return
      }
      if (res?.isAgreed === 0) {
        window.location.href = `/solar/metis/platform-agreement?redirect=${encodeURIComponent(window.location.href)}`
      } else if (res?.isRenewed === 0) {
        setVisible(true)
      }
    })
  }, [window.location.pathname])

  const handleOk = () => {
    postAgreement().finally(() => {
      setVisible(false)
    })
  }

  const handleAgreeAuth = () => {
    agreeAuthorization().finally(() => {
      updateShowAuthorizationModal(false)
    })
  }

  const handleRefuseAuth = (id: any) => {
    const formData: any = new FormData()
    formData.append('id', id)
    addReadTimes(formData)
  }

  const footer = <Button type="primary" onClick={handleOk}>我知道了</Button>
  return <>
    <Modal zIndex={10000} footer={[footer]} className={styles.agreement} width={696} visible={visible} closable={false}>
      <div className={styles.agreementContainer}>
        <div className={styles.agreementHeader}>
          <div className={styles.agreementHeaderLeft}>
            <Image className={styles.agreementIcon} preview={false} src="//pages.anjukestatic.com/fe/esf/img/35110e5a/Icon／Warning@2x.png" alt=""></Image>
            <span>请认真阅读平台协议</span>
          </div>
        </div>
        <div className={styles.agreementBody}>
          <div style={{ marginBottom: '24px' }}>
            <p className={styles.agreementDetailTitle}>本平台<span style={{ color: '#FF4D13' }}>禁止</span>账号转移或泄露等行为</p>
            <p className={styles.agreementDetail}>禁止平台员工非经您书面授权操作您账号。</p>
            <p className={styles.agreementDetail}>禁止平台员工将自己设置为您账号管理员。</p>
            <p className={styles.agreementDetail}>禁止平台员工将自己手机号绑定您的账号。</p>
            <p className={styles.agreementDetail}>禁止平台员工将非您本人或公司经纪人挂靠在您账号。</p>
          </div>
          <div style={{ marginBottom: '24px' }}>
            <p className={styles.agreementDetailTitle}>请您妥善保管好自己的账号相关信息</p>
            <p className={styles.agreementDetail}>请您妥善管理自己<span style={{ color: '#FF4D13' }}>的账号、密码、验证码及账号权益等</span>，不建议或请谨慎将账号相关信息提供给非本人或非本公司的员工使用。如因您本人账号管理不善或不当授权导致信息泄露或其他风险的，<span style={{ color: '#FF4D13' }}>您须自行承担相应责任。</span></p>

          </div>
          <p className={styles.agreementDetail}>如您的账号发现异常或发现本平台员工存在违反上述禁止事项的，同时您可及时与平台联系进行账号申诉或投诉。</p>
        </div>
      </div>
    </Modal>
    <Modal
      visible={showAuthorizationModal}
      title="系统消息"
      className={styles.authModal}
      footer={<div className={styles.authModalFooter}>
        <Space size={48}>
          <Button onClick={() => updateShowAuthorizationModal(false)}>不同意</Button>
          <Button type="primary" onClick={handleAgreeAuth}>同意</Button>
        </Space>
      </div>}
      width={696}
      onCancel={() => updateShowAuthorizationModal(false)}
    >
      <div className={styles.authModalBody}>
        <div className={styles.authModalTitle}>{authorizationModalData.resourceName}</div>
        <div className={styles.authModalContent}>{authorizationModalData.remindContent}</div>
      </div>
    </Modal>
  </>
}

export default AgreementModal
